import React from 'react'
import type { TypingIndicatorProps } from '../../types'

export const TypingIndicator: React.FC<TypingIndicatorProps> = ({
  typingUsers = [],
}) => {
  if (typingUsers.length === 0) return null

  const displayUsers = typingUsers.slice(0, 3)
  const remainingCount = typingUsers.length - 3

  return (
    <div className="px-4 py-2 flex items-center gap-3 min-h-10">
      <div className="relative h-7 flex">
        {displayUsers.map((user, index) => (
          <div
            key={user.id}
            className="absolute w-7 h-7 rounded-full bg-white dark:bg-background border-2 border-white dark:border-background overflow-hidden"
            style={{
              left: `${index * 20}px`,
              zIndex: 3 - index,
            }}
          >
            {user.avatar ? (
              <img
                src={user.avatar}
                alt={user.name}
                className="w-full h-full rounded-full object-cover"
              />
            ) : (
              <div className="w-full h-full rounded-full bg-gray-300 dark:bg-muted flex items-center justify-center text-xs font-medium text-white dark:text-foreground">
                {user.name.charAt(0).toUpperCase()}
              </div>
            )}
          </div>
        ))}

        {remainingCount > 0 && (
          <div
            className="absolute w-7 h-7 rounded-full bg-gray-200 dark:bg-muted flex items-center justify-center text-gray-600 dark:text-muted-foreground text-xs"
            style={{
              left: `${displayUsers.length * 20}px`,
              zIndex: 0,
            }}
          >
            +{remainingCount}
          </div>
        )}
      </div>

      <div className="flex items-center gap-2 text-gray-600 dark:text-muted-foreground text-sm">
        <span className="inline-flex gap-0.5">
          <span
            className="w-2 h-2 bg-gray-400 dark:bg-muted-foreground rounded-full animate-bounce"
            style={{ animationDelay: '0s', animationDuration: '1.4s' }}
          ></span>
          <span
            className="w-2 h-2 bg-gray-400 dark:bg-muted-foreground rounded-full animate-bounce"
            style={{ animationDelay: '0.2s', animationDuration: '1.4s' }}
          ></span>
          <span
            className="w-2 h-2 bg-gray-400 dark:bg-muted-foreground rounded-full animate-bounce"
            style={{ animationDelay: '0.4s', animationDuration: '1.4s' }}
          ></span>
        </span>
        <span className="text-gray-600 dark:text-muted-foreground italic">
          {typingUsers.length === 1
            ? `${typingUsers[0].name} is typing`
            : `${typingUsers.length} people are typing`}
        </span>
      </div>
    </div>
  )
}
